import { RgbaColor } from "react-colorful";

export default function convertRGBAObjectToRGBACSS(color: RgbaColor) {
  const values = Object.values(color).join(",");
  const requiredValue = `rgba(${values})`;
  return requiredValue;
}
